import React from 'react';
import HomeCard from "./HomeCard";
import HomeStatCard from "./HomeStatCard";
import {Clock, Edit, Upload, Video} from "lucide-react";

const HomeShortsContent = () => {
    return (
        <HomeCard>
            <h2 className="text-2xl font-bold mb-6">Shorts Overview</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                <HomeStatCard title="Total Shorts" value="127" icon={Video} trend={3.2} />
                <HomeStatCard title="Published" value="98" icon={Upload} trend={1.5} />
                <HomeStatCard title="In Queue" value="18" icon={Clock} trend={-2.1} />
                <HomeStatCard title="Drafts" value="11" icon={Edit} trend={0.8} />
            </div>
            {/* Add a table or grid of recent shorts here */}
        </HomeCard>

    );
};

export default HomeShortsContent;
